<template>
  <div class="homecontainer" :style="' background-color:'+String(backgoundcolor)">
    <!--     <GoodTitle :goodname="goodname" :goodinfo="goodinfo" :fontcolor="fontcolor" />-->
    <div class="home_title">
      <p class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?textname[0]:textnameEn[0]">
        {{$i18n.locale=='zh_HK'?textname[0]:textnameEn[0]}}</p>
      <h1 class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?textname[1]:textnameEn[1]">
        {{$i18n.locale=='zh_HK'?textname[1]:textnameEn[1]}}</h1>
      <!--文字栏-->
      <div class="contentdiv ">
        <div class="left wow slideInLeft" :style="{height:leftHeight}">
          <p v-html="$i18n.locale=='zh_HK'?titleDescribe:titleDescribeEn">
            {{$i18n.locale=='zh_HK'?titleDescribe:titleDescribeEn}}</p>
        </div>
        <div class="right wow slideInRight">
          <div class="product-content" ref="getheight" style="background-color: #2FA8DB">
            <div class="p-video">
              <video-player
                x5-playsinline=""
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
              ></video-player>
            </div>
          </div>
        </div>
      </div>
      <div class="but wow slideInUp">
        <button class="button " @click="routerpush('/about')">{{$t('header.Learnmore')}}</button>
      </div>
    </div>
    <img :src="imgsrc">
  </div>
</template>

<script>

  import GoodTitle from '../../comcomponents/GoodTitle'
  import {WOW} from 'wowjs';
  import {getListHome} from '@/api/home';

  export default {
    name: '',
    components: {
      GoodTitle
    },
    props: ['goodname', 'goodinfo', 'fontcolor', 'imgsrc', 'backgoundcolor'],

    data() {
      return {
        baseURL: process.env.BASE_API,
        listhome: '',
        textname: [],
        textnameEn: [],
        lang: localStorage.getItem("lang"),
        titleDescribe: '',
        titleDescribeEn: '',
        src: {
          zh: "",
          en: "",
        },
        leftHeight: 0,

      }
    },
    computed: {
      // videoSrc:"https://www.noahsolutions.net/cadt-api/img/formCommodity/2021_6_0/1623207807081.mp4",
      playerOptions() {
        const playerOptionsObj = {
          // playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度[0.5, 1.0, 1.5, 2.0, 4.0, 8.0]
          controls: true,
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: true, // 视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          // language: "zh_HK",
          aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "",
              src: localStorage.getItem("lang") == 'zh_HK' ? this.src.zh : this.src.en, //url地址
              // src: "https://www.noahsolutions.net/cadt-api/img/formCommodity/2021_6_0/1623207807081.mp4", //url地址
            }
          ],
          //poster: "../assets/img/home_top.jpg", //你的封面地址
          // width: document.documentElement.clientWidth,
          // notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            fullscreenToggle: true, //全屏按钮
            timeDivider: false, //当前时间和持续时间的分隔符
            durationDisplay: false, //显示持续时间
            remainingTimeDisplay: false, //是否显示剩余时间功能
          }
        }
        return playerOptionsObj
      }
    },
    //页面初始化
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
      //监听高度
      window.onresize = () => {
        this.leftHeight = this.$refs.getheight.offsetHeight + 'px';
        // console.log(this.leftHeight)
      }
    },
    created() {
      this.getListHome();

    },
    methods: {
      routerpush(to) {
        this.$router.push(to)
      },
      //获取视频
      getListHome() {
        getListHome().then(response => {
          const data = response.data;
          this.listhome = data.data;
          this.listhome[0].list.forEach((item, index) => {
            this.textname.push(item.name);
            this.textnameEn.push(item.nameEn);
          })
          this.titleDescribe = this.listhome[0].titleDescribe;
          this.titleDescribeEn = this.listhome[0].titleDescribeEn;
          this.videolinkzn = this.baseURL + "/img" + data.data[0].videolinkzn;
          this.videolinken = this.baseURL + "/img" + data.data[0].videolinken;
          this.src.zh = this.videolinkzn;
          this.src.en = this.videolinken;
          this.leftHeight = this.$refs.getheight.offsetHeight + 'px';
          // console.log(this.height)
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {

    .homecontainer {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      min-height: 500px;
      font-size: 1em;
      /*padding-top:10%;*/
      margin-bottom: 13px;

      .home_title {
        position: absolute;
        top: 8%;
        left: 50%;
        width: 80%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        font-size: 2em;
        z-index: 999;
        color: white;

        p {
          font-size: 1.5em;

        }

        h1 {
          font-size: 2.6em;
        }

        .contentdiv {
          width: 100%;
          display: flex;
          justify-content: space-around;
          margin-top: 7%;
          height: 15.2vw;

          .left {
            overflow: hidden;
            margin-top: -50px;
            text-align: left;
            padding: 2% 2% 2% 5%;
            background-color: rgba(139, 0, 0, 0.45);
            color: white;
            width: 55%;
            /*height: 100%;*/
            font-size: 0.5em;
            /*text-align: left;*/
            overflow: auto;

            p {
              font-size: 1em;
              line-height: 1.5em;
              font-weight: lighter;
            }
          }

          /*隐藏滚动条并可以滚动内容*/

          .left::-webkit-scrollbar {
            display: none;
          }

          .right {
            /*border: 1px dashed #000000;*/
            /*background-color: white;*/
            width: 37%;
            /*height: 270px;*/

            margin-top: -50px;
          }
        }

        .but {
          padding-top: 4%;

          .button {
            background: rgba(0, 0, 0, 0);
            border: 1.5px solid white;
            color: white;
            padding: 5% 2vw;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 0.8em;
            transition: all 0.4s; //设置动画执行的时间为0.6s
            cursor: pointer;
          }

          .button:hover {
            transform: scale(0.9);
          }
        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    /deep/ .vjs-custom-skin > .video-js .vjs-control {
      width: 1.2em;
    }

    /deep/ .video-js .vjs-slider {
      width: 2em;
    }

    /deep/ .vjs-progress-holder {
      /*display: none;*/
    }

    /deep/ .vjs-icon-placeholder {
      /*display: none;*/
    }

    /deep/ .vjs-icon-placeholder {
      position: fixed;
      margin-top: -20px;
      margin-left: -10px;
    }

    /*/deep/ .video-js .vjs-control-bar {*/
    /*  width: 60% !important;*/
    /*  height: 40%;*/
    /*  display: block;*/
    /*}*/
    .homecontainer {
      position: relative;
      width: 100%;
      /*top: -150px;*/
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      font-size: 1em;
      /*padding-top:10%;*/
      margin-bottom: 13px;

      .home_title {
        position: absolute;
        top: 4%;
        left: 50%;
        width: 90%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        font-size: 2em;
        z-index: 999;
        color: white;

        p {
          font-size: 1.5em;

        }

        h1 {
          font-size: 2.6em;
        }

        .contentdiv {
          width: 100%;
          display: flex;
          justify-content: space-around;
          margin-top: 6%;
          height: 21.1vw;

          .left {
            overflow: hidden;
            margin-right: 2vw;
            text-align: left;
            padding: 2% 2% 2% 10%;
            background-color: rgba(139, 0, 0, 0.45);
            color: white;
            width: 65%;
            height: 100%;
            font-size: 1.3em;
            overflow: auto;
            /*text-align: left;*/

            /*width: 65%;*/
            /*transform: scale(0.9);*/
            text-align: left;
            margin-top: -5%;

            p {
              margin-left: -15%;
              /*width: 135%;*/
              /*line-height: 98%;*/
              line-height: 2.1vw;

              * {
                overflow: hidden;
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }

              font-size: 0.5em;
              font-weight: lighter;
            }
          }

          .right {
            overflow: hidden;
            /*background-color: white;*/
            width: 50%;
            /*height: 15vh;*/
            margin-top: -5%;
          }
        }

        .but {
          margin-top: -2%;

          .button {
            background: rgba(0, 0, 0, 0);
            border: 1.5px solid white;
            color: white;
            padding: 5% 2vw;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 0.8em;
          }
        }


      }

      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/homecomponents/GoodBriefInfo.vue